<template>
  <svg
    version="1.1"
    class="ttl"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1191 424.7"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          class="st0"
          d="M850.9,51.9v-2.6H861v-5.1h5.1v2.5h2.5v-2.5h2.6v-2.6H861v2.6h-7.6v-2.6h5.1v-5.1h2.5v-7.6h-10.1v-2.6h12.7v-5.1h5.1v5.1h12.7v2.6h-7.6v7.6h-5.1v-7.6h-2.5v7.6h-2.5V39h12.7v5.1h-2.5v2.5h-2.5v2.5h10.1v2.6h-12.7v-2.6h-5.1v2.6h-12.8V51.9z M850.9,36.7v-2.6h2.5v-2.5h5.1v2.5H856v2.6H850.9z M881.3,36.7h-5.1v-5.1h2.6v2.5h2.5V36.7z"
        />
        <path
          class="st0"
          d="M893,51.9v-2.6h2.6v-2.5h2.5v-2.5H893v-2.6h2.6v-2.5H893v2.5h-2.5v10.2h-7.6v-2.6h2.5v-5.1h-2.5v-2.6h2.5v-10h-2.5v-2.5h2.5V24h5.1v5.1h2.5v-2.6h2.6V24h15.2v2.5h-2.6v2.6h5.1v15.2h-5.1v2.5h2.6v2.5h2.5v2.6h-5.1v-2.6h-2.5v-5.1h-2.5v2.5h-2.6v2.5h-2.5v2.6H893V51.9z M893,39.2v-7.6h-2.5v7.6H893z M898.1,29.1h5.1v-2.6h-5.1V29.1z M900.6,41.8v-2.5h2.6v-2.5h2.5v-5.1h-2.5v5.1h-2.6v2.5h-2.5v2.5H900.6z M900.6,36.7v-5.1h-2.5v5.1H900.6z M908.2,41.8v-2.5h-2.5v2.5H908.2z M910.7,36.7v-5.1h-2.6v5.1H910.7z"
        />
      </g>
      <path
        class="st0"
        d="M286.9,31.6v-2.4h26.7V34h-2.4v2.4h-2.4v2.4h-2.4v2.4H304v2.4h-2.4v-4.9h2.4v-2.4h2.4v-2.4h2.4v-2.4L286.9,31.6L286.9,31.6z M291.8,41.3v-2.4h4.9v2.4h2.4v2.4h2.4v2.4h2.4v2.4h2.4V51h-4.9v-2.4H299v-2.4h-2.4v-2.4h-2.4v-2.4L291.8,41.3L291.8,41.3z"
      />
      <path
        class="st0"
        d="M323.3,41.3h-4.8V34h4.8V41.3z M320.9,51v-2.4h4.9v-2.4h4.8v-4.9h2.4V34h4.8v7.3h-2.4v4.9H333v2.4h-4.9V51H320.9z M330.5,41.3h-4.8V34h4.8V41.3z"
      />
      <path
        class="st0"
        d="M347.5,51v-2.4h7.3v-2.4h4.8v-2.4h2.4v-4.9h2.4v-7.3h-7.3V34h-2.4v2.4h-2.4v2.4h-4.8v-2.4h2.4V34h2.4v-2.4h2.4v-7.3h4.8v4.9h9.7v9.7h-2.4v4.9h-2.4v2.4H362v2.4h-4.9V51H347.5z"
      />
      <path
        class="st0"
        d="M403.2,51h-14.5v-2.4h-2.4v-2.4h-2.4v-4.9h2.4v-2.4h2.4v-2.4h2.4v-4.9h-2.4v-7.3h4.9v7.3h2.4V34h7.3v2.4H396v2.4h-4.8v2.4h-2.4v4.9h2.4v2.4h12.1V51H403.2z"
      />
      <path
        class="st0"
        d="M422.6,51v-2.4h4.9v-2.4h4.8v-2.4h2.4v-4.9h2.4v-7.3h-14.5v7.3h-4.9v-9.7h9.7v-4.9h4.8v4.9h9.7v9.7h-2.4v4.9h-2.4v2.4h-2.4v2.4h-4.9V51H422.6z"
      />
      <path
        class="st0"
        d="M446.9,41.3v-2.4h4.9v-2.4h4.9v-2.4h4.8v-2.4h2.4v-2.4h2.4v-2.4h4.9v2.4h-2.4v2.4h-2.4v2.4H464v17h-5V38.9h-4.9v2.4C454.1,41.3,446.9,41.3,446.9,41.3z"
      />
      <path
        class="st0"
        d="M478.4,29.2v-2.4h7.3v2.4h4.8v2.4h-7.3v-2.4H478.4z M478.4,51v-2.4h7.3v-2.4h4.8v-2.4h2.4v-2.4h2.4v-4.8h2.4v-4.9h4.9v4.9h-2.4v4.8h-2.4v2.4h-2.4v2.4H493v2.4h-4.9V51H478.4z"
      />
      <path
        class="st0"
        d="M512.3,51h-4.8V24.4h4.8v9.7h4.9v2.4h4.9v2.4h4.8v2.4h-7.3v-2.4h-4.8v-2.4h-2.4V51H512.3z M517.1,29.2v-2.4h4.9v2.4h2.4v2.4h-4.9v-2.4H517.1z M529.3,29.2h-4.9v-2.4H522v-2.4h4.8v2.4h2.4L529.3,29.2L529.3,29.2z"
      />
      <path
        class="st0"
        d="M539,51v-2.4h4.9v-2.4h4.8v-2.4h2.4v-4.9h2.4v-7.3H539v7.3h-4.9v-9.7h9.7v-4.9h4.8v4.9h9.7v9.7h-2.4v4.9h-2.4v2.4h-2.4v2.4h-4.9V51H539z"
      />
      <path
        class="st0"
        d="M560.8,51v-2.4h4.9v-2.4h4.8v-2.4h2.4v-2.4h2.4v-4.8h2.4v-7.3h-14.5v-2.4h14.5v-2.4h-2.4V22h4.9v2.4h2.4v12.1h-2.4v7.3h2.4v2.4h2.4v2.4h2.4V51h-4.9v-2.4h-2.4v-2.4h-2.4v-2.4h-2.4v2.4h-2.4v2.4H568V51H560.8z M589.8,26.8H585v-2.4h-2.4V22h4.9v2.4h2.4v2.4H589.8z"
      />
      <path
        class="st0"
        d="M614.1,48.6v-2.4h4.9v-2.4h2.4v-9.7H619v-2.4h-4.9V39h-2.4v4.9h-2.4v2.4H602v-2.4h-2.4v-7.3h2.4v-2.4h2.4v-2.4h2.4v-2.4h14.5v2.4h2.4v2.4h2.4v9.7h-2.4v2.4h-2.4v2.4h-7.2V48.6z M606.8,43.8v-4.9h2.4V34h2.4v-2.4h-2.4V34h-2.4v2.4h-2.4v7.3h2.4V43.8z"
      />
      <path
        class="st0"
        d="M638.3,51v-2.4h7.3v-2.4h4.8v-2.4h2.4v-4.9h2.4v-9.7h-19.4v-2.4h24.3v12.1h-2.4v4.9h-2.4v2.4h-2.4v2.4H648V51H638.3z"
      />
      <path
        class="st0"
        d="M667.4,36.5v-2.4h19.4v7.3h-2.4v2.4H682v-7.3H667.4z M669.8,51v-2.4h2.4v-2.4h2.4v-7.3h4.8v7.3H677v2.4h-2.4V51H669.8z"
      />
      <path
        class="st0"
        d="M694,41.3v-2.4h4.9v-2.4h4.9v-2.4h4.8v-2.4h2.4v-2.4h2.4v-2.4h4.9v2.4h-2.4v2.4h-2.4v2.4H711v17h-4.9V38.9l0,0h-4.9v2.4C701.2,41.3,694,41.3,694,41.3z"
      />
      <path
        class="st0"
        d="M728,51h-4.9v-4.9h2.4v-4.9h2.4V26.8h4.9v14.5h-2.4v4.9H728V51z M742.5,51h-7.3V24.4h4.9v24.2h2.4L742.5,51L742.5,51z M742.5,48.6v-7.3h2.4v-4.8h4.9v4.8h-2.4v4.9H745v2.4C745,48.6,742.5,48.6,742.5,48.6z"
      />
      <path
        class="st0"
        d="M757,51h-4.9v-4.9h2.4v-7.3h2.4v-9.7h4.9v9.7h-2.4v7.3H757V51z M776.4,34.1h-7.3v-2.4h-2.4v-4.9h2.4v-2.4h7.3v2.4h2.4v4.9h-2.4V34.1z M778.9,51H774v-4.9h-2.4v-4.9h-2.4v-4.8h4.8v4.8h2.4v4.9h2.4V51H778.9z M774,31.6v-4.9h-2.4v4.9H774z"
      />
      <path
        class="st0"
        d="M781.3,51v-2.4h4.9v-2.4h4.9v-2.4h2.4v-2.4h2.4v-4.8h2.4v-7.3h-14.5v-2.4h19.4v9.7h-2.4v7.3h2.4v2.4h2.4v2.4h2.4V51h-4.9v-2.4h-2.4v-2.4h-2.4v-2.4h-2.4v2.4h-2.4v2.4h-4.9V51H781.3z"
      />
      <path
        class="st0"
        d="M817.6,31.6v-2.4h7.3v-4.9h4.9v4.9h9.7v2.4h-12.1V34h4.8v2.4h2.4v2.4h2.4v2.4h-2.4v4.9h-4.9v-2.4h2.4v-2.4h-2.4v2.4h-2.4v4.8h12.1V51h-14.5v-2.4h-2.4v-4.8h2.4v-2.4h2.4V39h2.4v-2.4h-4.9V39h-2.4v4.9h-4.9V39h2.4v-2.4h2.4v-4.9L817.6,31.6L817.6,31.6z M841.9,38.9H837v-2.4h4.9V38.9z"
      />
      <polygon
        class="st0"
        points="256.5,18.2 261.3,18.2 261.8,13.3 256.9,13.3 256.3,18 251.6,18 251,23 256.1,23 	"
      />
      <polygon
        class="st0"
        points="265.5,36.6 265.7,34 268.4,34 268.9,29 265.2,29 265.5,25.3 242.9,25.3 242.5,28.8 238.7,28.8 236.4,50.7 240.3,50.7 239.9,54.5 262.7,54.5 263,50.7 266.8,50.7 267.4,45.5 264.6,45.5 264.7,44 260.9,44 261.6,36.6 	"
      />
      <polygon class="st0" points="930.7,23.4 947.1,23.4 948.4,37 932,37 	" />
      <polygon class="st0" points="932.2,39.4 948.7,39.4 950,53.2 933.5,53.2 	" />
      <polygon class="st0" points="949.3,23.4 965.7,23.4 967.1,37 950.6,37 	" />
      <polygon class="st0" points="950.9,39.4 967.4,39.4 968.8,53.2 952.2,53.2" />
    </g>
    <g>
      <path
        class="st1"
        d="M1154.9,400.4h-7.1v21.2h-5.3v-21.2h-7.1v-3.6h19.4L1154.9,400.4L1154.9,400.4z"
      />
      <path
        class="st1"
        d="M1186.8,421.6h-5.3v-21.2h-5.3v21.2h-5.3v-21.2h-5.3v21.2h-5.3v-24.8h26.5L1186.8,421.6L1186.8,421.6z"
      />
    </g>
    <g>
      <g>
        <polygon
          class="st2"
          points="1096.9,142.5 1100.7,162.7 1101.8,168.6 1164.7,309.9 1169,308.9 1179,339.6 1175.5,377.6 
          1042,377.6 1041,370.7 1036.6,370.7 1035.6,364.1 1034.7,357.3 1033.7,350.7 1032.7,344 1028.3,344 1027.4,337.3 1026.4,330.8 
          1025.5,324.1 1021.1,324.1 1020.2,317.5 1019.3,311.1 1018.3,304.6 1015,281.5 1089.5,281.5 1086.9,266.2 1004.4,266.2 
          1003.5,260 1002.6,253.7 998.4,253.7 997.5,247.4 996.7,241.2 995.8,235 991.6,235 990.7,228.8 989.9,222.7 989.1,216.6 
          988.2,210.6 984.1,210.6 983.2,204.5 982.4,198.4 981.6,192.5 977.4,192.5 976.6,186.4 975.8,180.4 975,174.6 974.2,168.6 
          970.1,168.6 969.3,162.7 968.6,156.9 967.8,151.1 967,145.3 966.3,139.5 962.2,139.5 961.4,133.7 960.7,128 959.9,122.3 
          955.9,122.3 951.5,88.6 959,89.4"
        />
        <polygon
          class="st2"
          points="862.4,298.1 866.6,344 871,344 874.1,377.6 1024.3,377.6 1023.4,370.7 1022.4,364.1 1021.5,357.3 
          1018.4,338.1 1013.5,330.8 1012.5,324.1 962.7,174.6 961.9,168.6 957.5,140.3 823.8,93.1 820.7,101.5 823.2,133.7 827.2,133.7 
          829.2,156.9 833.3,156.9 836.3,192.5 840.4,192.5 842.5,216.6 846.7,216.6 849.9,253.7 854.2,253.7 855.9,272.6 894.7,272.6 		"
        />
        <path
          class="st2"
          d="M798.9,377.6h61.9l-3.5-40.3l-43.7-179.6l-3-29.6l-0.9-11.4l-58.4,10.4l-53.5,26.1l1.2,33.4h7.7l-2.6,27.1
          l1.3,33.8h8l-1.1,66.7l1.4,36.5h4.4l1.1,26.9h61.9l-2.8-38.9l-9.6-13.7l-1.5-33.3h17.2l0.4,6.5l9.1-0.5l-3.5,16.2l2.1,36.8h4.4
          l1.8,26.9H798.9z M746.1,214.7l-10.5-28.3h58.6l-5.8,34.4L746.1,214.7z"
        />
        <polygon
          class="st2"
          points="157.7,377.6 159.7,364.1 164.1,364.1 167.9,337.3 172.3,337.3 175.1,317.5 179.4,317.5 183,291.7 
          187.3,291.7 189.1,279 193.4,279 196.9,253.7 201.1,253.7 203.6,235 207.9,235 211.1,210.6 215.3,210.6 218.5,186.4 222.7,186.4 
          225,168.6 229.1,168.6 232.2,145.3 236.2,145.3 238.5,128 242.5,128 243.2,123 243.3,122.3 244,116.5 246.4,87.8 208,109.8 
          164.7,186.4 163.8,192.5 146.8,168.6 147.8,162.7 151.9,162.7 153.7,151.1 157.8,151.1 160.5,133.7 164.6,133.7 169.6,102.3 
          161.1,91.5 10.4,339.8 3,377.6 64.9,377.6 67.3,364.1 71.7,364.1 74,350.7 78.4,350.7 82.9,324.1 87.3,324.1 90.6,304.6 95,304.6 
          98.2,285.3 102.5,285.3 105.7,266.2 139.8,266.2 103.2,339.8 95.9,377.6 		"
        />
        <path
          class="st2"
          d="M653.5,116.5l-38.5,7.4l-54.5,215.2l-0.4,38.4H622l-0.3-38.2l-5.7-73.2h77.4c0,0-1.8-51.3-1.9-51L653.5,116.5
          z M616.2,184.4l-0.2-21.6h24.7l0.3,21.6H616.2z"
        />
        <polygon
          class="st2"
          points="478.4,131.9 527,90.7 531.4,95.8 530.6,128 519.2,127.9 525.9,152.9 525.1,186.4 520.9,186.4 
          520,222.7 499,222.7 498.1,247.4 481.2,247.4 480.5,266.2 467.8,266.2 467.5,272.6 460.5,272.7 461.9,300.5 460.3,337.3 
          455.9,337.3 454,377.6 392.1,377.6 394.8,337.5 400,324.1 408.1,266.2 395.3,266.2 396.6,247.4 388.1,247.4 379.6,247.4 
          381.9,216.6 365.3,216.6 368.1,181.3 429.8,116.5 421,91.2 439.3,90.2 437.6,122.3 433.5,122.3 430.8,169.1 475.7,169.1 		"
        />
        <polygon
          class="st2"
          points="312.5,377.6 313.2,370.7 317.6,370.7 321.3,330.8 325.6,330.8 329,295.2 323.8,266.2 340,266.2 
          343.3,228.8 347.5,228.8 349.6,204.5 353.7,204.5 356.8,168.6 360.9,168.6 363.3,139.5 367.4,139.5 370,107.7 360.3,89.4 
          265.8,123.5 180.8,339 177.3,364.1 176.4,370.7 175.4,377.6"
        />
      </g>
      <g>
        <polygon
          class="st3"
          points="1179,339.6 1182.7,360.2 1182.7,377.6 1042,377.6 1041,370.7 1036.6,370.7 1035.6,364.1 
          1034.7,357.3 1033.7,350.7 1032.7,344 1028.3,344 1028,340.6"
        />
        <polygon
          class="st3"
          points="866.6,344 871,344 874.1,377.6 1024.3,377.6 1023.4,370.7 1022.4,364.1 1021.5,357.3 1018.4,338.1 
          870.8,340.6"
        />
        <path
          class="st3"
          d="M791.8,338.4l0.8,12.3h4.4l1.8,26.9h0.2h61.9l-3.5-40.3L791.8,338.4z M713.5,338.9l0.2,11.8h4.4l1.1,26.9
          h61.9l-2.8-38.9L713.5,338.9z"
        />
        <polygon
          class="st3"
          points="103.2,339.8 95.9,377.6 157.7,377.6 159.7,364.1 164.1,364.1 167.5,340.4"
        />
        <polygon
          class="st3"
          points="10.4,339.8 3,377.6 64.9,377.6 67.3,364.1 71.7,364.1 74,350.7 78.4,350.7 80,340.9"
        />
        <path class="st3" d="M560.5,339.1l-0.4,38.4H622l-0.5-37.9L560.5,339.1z" />
        <polygon class="st3" points="455.9,337.3 454,377.6 392.1,377.6 394.8,337.5" />
        <polygon
          class="st3"
          points="180.8,339 177.3,364.1 176.4,370.7 175.4,377.6 312.5,377.6 313.2,370.7 317.6,370.7 320.5,340.1 
          189.3,339.9"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter-mask"
        filterUnits="userSpaceOnUse"
        x="2.6"
        y="55.7"
        width="1167.4"
        height="283.7"
      >
        <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
      </filter>
    </defs>
    <mask maskUnits="userSpaceOnUse" x="2.6" y="55.7" width="1167.4" height="283.7" id="ttl-mask">
      <g class="st4">
        <g>
          <polyline
            class="st5"
            points="1039.5,166 1043.6,166 1047.7,166 1051.8,166 1055.9,166 1060.1,166 1064.2,166 1068.3,166 
            1072.4,166 1076.5,166 1080.6,166 1084.7,166 1088.9,166 1093,166 1097,166"
          />
          <polygon
            class="st5"
            points="1180.6,340.8 1176.7,321 1172.4,321 1169.8,308.1 1165.5,308.1 1161.8,288.7 1157.5,288.7 
            1155.1,276 1150.8,276 1146,250.8 1141.8,250.8 1138.3,232.2 1134,232.2 1131.8,219.9 1127.6,219.9 1124.2,201.7 1120,201.7 
            1117.8,189.8 1113.7,189.8 1110.4,171.9 1106.3,171.9 1105.2,166 1031.3,166 1030.4,160.2 1026.2,160.2 1023.6,142.7 
            1096.9,142.7 1094.8,131.1 1090.8,131.1 1088.8,119.7 1084.8,119.7 1081.8,102.8 1077.8,102.8 1075.8,91.6 1071.8,91.6 
            1070.8,86 951,86 951.7,91.6 955.7,91.6 957.9,108.4 962,108.4 965.8,136.9 969.8,136.9 973,160.2 977.1,160.2 979.5,177.9 
            983.6,177.9 986.9,201.7 991,201.7 993.6,219.9 997.8,219.9 999.5,232.2 1079.4,232.2 1080.4,238.4 1084.7,238.4 1088.9,263.3 
            1012.2,263.3 1015.9,288.7 1020.2,288.7 1023,308.1 1027.3,308.1 1031.1,334.2 1035.5,334.2 1036.5,340.8"
          />
          <polyline
            class="st5"
            points="870.6,340.8 1019,340.8 1016.2,321 1011.9,321 1007.4,288.7 1003.1,288.7 1000.5,269.6 
            996.2,269.6 992.8,244.6 988.5,244.6 986,226.1 981.8,226.1 978.5,201.7 974.4,201.7 970.4,171.9 966.3,171.9 965.5,166 
            887.4,166 886.8,160.2 886.2,154.3 885.6,148.5 885,142.7 958.4,142.7 957.6,136.9 956.9,131.1 952.8,131.1 952.1,125.5 
            951.3,119.7 950.6,114.1 946.6,114.1 945.9,108.4 945.1,102.8 944.4,97.2 943.7,91.6 939.7,91.6 939,86 819.2,86 819.6,91.6 
            820.1,97.2 820.5,102.8 824.6,102.8 825,108.4 825.5,114.1 826,119.7 826.4,125.5 830.5,125.5 831,131.1 831.5,136.9 832,142.7 
            832.4,148.5 832.9,154.3 833.4,160.2 837.5,160.2 838,166 838.6,171.9 839.1,177.9 839.6,183.7 843.7,183.7 844.2,189.8 
            844.8,195.7 845.3,201.7 845.8,207.8 846.3,213.8 846.9,219.9 851.1,219.9 851.6,226.1 852.2,232.2 852.7,238.4 932.8,238.4 
            935.7,263.3 859.2,263.3 863.2,308.1"
          />
          <path
            class="st5"
            d="M819.3,136.9h-4.1l-3.1-39.7h-4l-0.4-5.6l-0.4-5.6h-112l2.5,68.3h4.1l2.3,59.5h4.2l4,100.7h4.3l1.1,26.3
            h61.1l-0.8-13.2h-4.4l-0.4-6.6l-3.1-51.4h-4.3l-0.7-12.5h17l0.4,6.3h4.3l3.4,51.2h4.3l1.8,26.2h61.1l-3.4-39.3h-4.3l-2.7-31.9
            h-4.3l-3.2-37.4h-4.2l-2.5-30.4h-4.2l-3.4-41.5H821L819.3,136.9L819.3,136.9z M742.9,154.3h41l3.6,53.5h-37.6l-0.6-12h-4.2
            L742.9,154.3z"
          />
          <polygon
            class="st5"
            points="163.2,340.8 165.1,327.7 169.5,327.7 173.2,301.5 177.5,301.5 180.2,282.3 184.5,282.3 188.1,257.1 
            192.3,257.1 194,244.6 198.3,244.6 201.6,219.9 205.8,219.9 208.3,201.7 212.5,201.7 215.7,177.9 219.8,177.9 222.9,154.3 
            227,154.3 229.3,136.9 233.4,136.9 236.4,114.1 240.4,114.1 242.6,97.2 246.6,97.2 248,86 196,86 193.6,102.8 189.6,102.8 
            186.2,125.5 182.2,125.5 180.5,136.9 176.4,136.9 173.8,154.3 169.8,154.3 168,166 143.3,166 145.2,154.3 149.3,154.3 153,131.1 
            157,131.1 158.8,119.7 162.9,119.7 165.5,102.8 169.5,102.8 172.1,86 120.2,86 118.2,97.2 114.2,97.2 111.2,114.1 107.2,114.1 
            103.2,136.9 99.1,136.9 97.1,148.5 93,148.5 89.8,166 85.7,166 83.5,177.9 79.4,177.9 76.2,195.7 72,195.7 69.8,207.8 
            65.6,207.8 62.2,226.1 58,226.1 55.7,238.4 51.5,238.4 48,257.1 43.8,257.1 40.2,276 36,276 33.5,288.7 29.2,288.7 24.2,314.6 
            19.9,314.6 17.4,327.7 13,327.7 10.4,340.8 71.5,340.8 73.8,327.7 78.2,327.7 80.5,314.6 84.8,314.6 89.2,288.7 93.5,288.7 
            96.8,269.6 101.1,269.6 104.3,250.8 108.5,250.8 111.6,232.2 145.3,232.2 144.3,238.4 140.1,238.4 138.2,250.8 133.9,250.8 
            130.9,269.6 126.7,269.6 122.6,295.2 118.3,295.2 116.2,308.1 111.8,308.1 108.6,327.7 104.3,327.7 102.1,340.8"
          />
          <path
            class="st5"
            d="M691.2,201.7H687l-2.3-70.6h-4.1L679.3,86H563.6l-3,254.8h61.1l-1-108.7h71.5L691.2,201.7z M640.2,131.1
            l0.8,46.7h-24.8l-0.3-46.6h24.4L640.2,131.1z"
          />
          <path
            class="st5"
            d="M499.3,213.8h-4.2h-4.2h-4.2h-4.2l-0.2,6.1l-0.2,6.2l-0.2,6.2h-4.2h-4.2h-4.2l-0.3,6.2h-4.2l-2.9,63.2h-4.3
            l-1.8,39.2h-61.1l2.2-32.8h4.3l3.4-51h4.2l1.6-24.9h-12.6l1.3-18.4h-16.7l0.9-12.1l0.5-6.1l0.4-6l0.4-6h-4.1h-4.1h-4.1h-4.1
            l0.5-6l0.5-6l0.5-5.9h4.1l2.7-34.8h4.1l0.4-5.8l0.4-5.7l0.9-11.3h4l1.7-22.4c0,0,51.7-0.3,51.9,0l-0.3,5.6h-4l-2,33.9h-4.1
            l-0.3,5.8l-0.3,5.8h4.1h4.1h4.1l-1.3,23.3h20.5l1.1-23.3h4.1h4.1h4.1l0.3-5.8l0.3-5.8l0.3-5.7h4l1.4-33.7c0,0,51.4-0.6,51.9,0
            l-0.1,5.6l-0.1,5.6h-4l-1.4,57.1h-4l-0.9,35.4h-4.1h-4.1h-4.1h-4.1H501L499.3,213.8L499.3,213.8z"
          />
          <polygon
            class="st5"
            points="332.4,257.1 328.9,295.2 324.6,295.2 321,334.2 316.7,334.2 316.1,340.8 180.7,340.8 183.4,321 
            187.8,321 192.2,288.7 196.5,288.7 199.1,269.6 203.4,269.6 206.7,244.6 210.9,244.6 214.2,219.9 218.4,219.9 221.6,195.7 
            225.8,195.7 228.9,171.9 233,171.9 235.2,154.3 239.3,154.3 242.3,131.1 246.3,131.1 248.5,114.1 252.5,114.1 256,86 371.9,86 
            371.4,91.6 370.9,97.2 370.5,102.8 370,108.4 366,108.4 365.5,114.1 365.1,119.7 364.6,125.5 364.1,131.1 363.6,136.9 
            359.5,136.9 359.1,142.7 289.7,142.7 289.1,148.5 288.4,154.3 284.3,154.3 283.7,160.2 283,166 357.1,166 356.6,171.9 
            352.5,171.9 351.9,177.9 351.4,183.7 350.9,189.8 350.4,195.7 346.3,195.7 345.7,201.7 345.2,207.8 344.7,213.8 344.1,219.9 
            343.6,226.1 343.1,232.2 267.3,232.2 266.5,238.4 265.8,244.6 261.7,244.6 261,250.8 260.3,257.1"
          />
        </g>
      </g>
    </mask>
    <g class="st6">
      <rect x="64.7" y="171.6" class="st7" width="1104.4" height="30.6" />
      <polygon class="st8" points="2.6,140.9 1168,140.9 1169,172.2 3.6,172.2" />
      <polygon class="st9" points="13.1,116.9 1170,116.9 1167.9,141.9 11,141.9" />
      <rect x="12.2" y="85.3" class="st10" width="1156.8" height="32.6" />
      <rect x="12.2" y="55.7" class="st11" width="1156.8" height="32.6" />
      <polygon class="st5" points="111.2,89.2 1085.1,89.2 1079.2,85.7 116.7,85.7" />
      <path
        class="st12"
        d="M1135.8,200.6l-15.8-0.2l-1.6-6h-6.2l-1.6-6h-6.2l1.8,6.4h6.2l1.5,5.5h-6.6l-1.6-5.9h-5.9l-1.6-6h-6.2
        l1.8,6.4h5.9l1.5,5.4h-6.3l-1.6-5.8h-6.2l-1.6-6h-6.2l1.8,6.4h6.2l1.5,5.3h-6.6l-1.6-5.7h-5.2l-1.6-6h-6.2l1.8,6.4h5.2l1.4,5.2
        h-5.6l-1.5-5.6h-5.6l-1.6-6h-6.5l1.8,6.6h5.9l1.4,4.9h-6.1l-1.5-5.5h-5.8l-1.1-5.9h-7.7l1.1,5.7h-5l-1.1-6h-6.2l1.1,6h-4.7l-1.1-6
        h-6.2l1.2,6.4h5l0.9,5.1h-5.4l-1-5.5h-5.2l-1.1-6h-6.2l1.2,6.4h5.2l0.9,5h-5.6l-1-5.5h-5.6l-1.1-6h-6.2l1.2,6.4h5.6l0.9,5h-6.1
        l-1-5.4h-6.2l1,5.3h-16.1l-1.2-6h-6.2l-1.2-6h-6.2l1.3,6.4h6.2l1.1,5.5h-6.6l-1.2-5.9h-5.9l-1.2-6h-6.2l1.3,6.4h5.9l1.1,5.4h-6.3
        l-1.2-5.8h-6.2l-1.2-6h-6.2l1.3,6.4h6.2l1.1,5.3H936l-1.2-5.7h-5.2l-1.2-6h-6.2l1.3,6.4h5.2l1.1,5.2h-5.6l-1.1-5.6h-5.6l-1.2-6
        h-6.5l1.3,6.6h5.9l1,4.9h-6.1l-1.1-5.5h-6l-0.7-6.2h-7.2l0.7,6h-5.4l-0.7-6h-6.2l0.7,6h-4.7l-0.7-6h-6.2l0.7,6.4h5l0.6,5.1h-5.4
        l-0.6-5.5h-5.2l-0.7-6h-6.2l0.7,6.4h5.2l0.6,5h-5.6l-0.6-5.5h-5.6l-0.7-6h-6.2l0.7,6.4h5.6l0.6,5h-6.1l-0.6-5.4h-6.2l0.6,5.3h-22.2
        l-0.6-4.7h6l-0.8-6.6h-6.6l0.7,5.8h-5.2l-0.7-6.2h-6l0.8,6.7h5.7l0.6,5h-6.1l-0.7-5.5h-6l-0.7-6.2h-6l0.8,6.7h6l0.6,5H798l-0.7-5.5
        h-5l-0.7-6.2h-6l0.8,6.7h5l0.6,5.1h-47l-0.2-5.9H740l-0.2-6.2h-6l0.2,6.6h4.8l0.2,5.5h-5.2l-0.2-5.9h-5l-0.2-6.2h-6l0.2,6.6h5
        l0.2,5.5h-5.4l-0.2-6h-5.5l-0.2-6.2h-6l0.2,6.6h5.5l0.2,5.5h-5.9l-0.2-6h-6l0.2,6h-17l-0.2-5.8h-6l-0.2-6.3h-6l0.2,6.8h6l0.2,5.4
        h-6.4l-0.2-5.8H669l-0.2-6.3h-6l0.2,6.8h5.7l0.2,5.4h-6.1l-0.2-5.8h-6l-0.2-6.3h-6l0.2,6.8h6l0.2,5.4h-6.4l-0.2-5.8h-5l-0.2-6.3h-6
        l0.2,6.8h5l0.2,5.4h-5.7l0.3-6.1h-5.5l0.3-6.3h-6l-0.3,6.3h-5.7l-0.3,6.1h-6.6l0.3-5.8h6.5l0.3-6.8h-6.6l-0.3,6.5h-5.4l0.3-6.3h-6
        l-0.3,6.3h-4.5l0.3-6.3h-6l-0.3,6.8h4.8l-0.3,5.6h-5.2l0.3-6.1h-5l0.3-6.3h-6l-0.3,6.8h5l-0.3,5.6h-5.4l0.3-6.1h-5.5l0.3-6.3h-6
        l-0.3,6.8h5.5l-0.3,5.6h-5.9l0.3-6.1h-6l-0.3,6.1h-62l0.1-6.5h-5.5l0.1-6.2h-6l-0.1,6.7h5.5l-0.1,6h-5.9l0.1-6.5h-6l0.1-6.2h-6
        l-0.1,6.7h6l-0.1,6h-6.4l0.1-6.5h-5.7l0.1-6.2h-6l-0.1,6.7h5.7l-0.1,6h-6.1l0.1-6.5h-6l0.1-6.2h-6l-0.1,6.7h6l-0.1,6h-6.4l0.1-6.5
        h-5l0.1-6.2h-6l-0.1,6.7h5l-0.1,6H441l0.1-6.5h-5.4l0.1-6.2h-6.2l-0.1,6.9h5.7l-0.1,5.8h-5.8l0.1-6.5h-5.8l0.5-5.8h-6.8l-0.7,6.7
        h6.8l-0.1,5.6h-7.4l0.6-5.9h-5.4l0.6-6.2h-6l-0.6,6.2h-4.5l0.6-6.2h-5.9l-0.7,6.6h4.8l-0.6,5.5h-5.2l0.6-5.9h-4.9l0.6-6.2h-6
        l-0.7,6.6h5l-0.5,5.5h-39l0.5-6h-5.5l0.5-6.2h-6l-0.6,6.7h5.5l-0.5,5.5h-5.9l0.5-6h-5.7l0.5-6.2h-6l-0.6,6.7h5.7l-0.5,5.5h-6.1
        l0.5-6h-6l0.5-6.2h-6l-0.6,6.7h6l-0.5,5.5H312l0.5-6h-5l0.5-6.2h-6l-0.6,6.7h5l-0.5,5.5h-5.4l0.5-6h-5.4l0.5-6.2H290l-0.6,6.9h5.7
        l-0.4,5.3h-5.8l0.5-6h-5.5l1-6.3l-6.8,0l-1.1,6.7l6.4,0l-0.5,5.6h-7.1l1.1-6.3h-5.4l1-6.2h-6l-1,6.2H261l1-6.2h-6l-1.1,6.7h4.8
        l-1,5.8h-5.2l1.1-6.3h-5l1-6.2h-6l-1.1,6.7h5l-1,5.8h-5.4l1.1-6.3h-5.4l1-6.2h-6l-1.1,6.7h5.4l-1,5.8h-5.8l1.1-6.3h-6l-1.1,6.3h-13
        l1.2-6H207l1.2-6.2h-6l-1.3,6.7h5.5l-1.1,5.5h-5.9l1.2-6h-6l1.2-6.2h-6l-1.3,6.7h6l-1.1,5.5H187l1.2-6h-5.7l1.2-6.2h-6l-1.3,6.7
        h5.7l-1.1,5.5h-6.1l1.2-6h-6l1.2-6.2h-6l-1.3,6.7h6l-1.1,5.5h-6.4l1.2-6h-5l1.2-6.2h-6l-1.3,6.7h5l-1.1,5.5h-5.4l1.2-6h-5.4
        l1.2-6.2h-6.2l-1.3,6.9h5.7l-1,5.3h-5.8l1.2-6h-5.5l1.6-5.9h-7.3l-1.6,5.6h-5.2l1.7-6.2h-6l-1.7,6.2h-4.5l1.7-6.2h-6L106,193h4.8
        l-1.6,5.8H104l1.7-6.3h-5l1.7-6.2h-6l-1.9,6.7h5l-1.6,5.8h-5.4l1.7-6.3h-5.4l1.7-6.2h-6l-1.9,6.7H88l-1.6,5.8h-5.8l1.7-6.3h-6
        l-1.7,6.3h-9.7l-20.2,50.1h1102L1135.8,200.6z M120.5,200.4h-5.1l1.6-5.8h5.1L120.5,200.4z M133.5,198.8h-7.1l1.4-5.2h6.7
        L133.5,198.8z M269.7,200.4h-5.1l1-5.8h5.1L269.7,200.4z M409.9,198.8h-5.1l0.5-5.5h5.1L409.9,198.8z M608.6,200.4h-5.2l0.3-5.6
        h5.2L608.6,200.4z M632.5,200.4h-5.2l0.3-5.6h5.2L632.5,200.4z M886.8,200.4l-0.6-5.2h5.3l0.6,5.2H886.8z M898.4,198.9l-0.6-5.3
        h6.8l1.1,5.3H898.4z M1032.5,200.4l-1-5.2h5.3l1,5.2H1032.5z M1044.7,199.9l-0.9-5h6.8l1.4,5H1044.7z"
      />
      <path
        class="st13"
        d="M1139,246.6v0.1l-1.9-9.3l-8.8,0.1l1.9,9.2h-9.9l-1.8-8.5l9.4-0.1l-1.9-9.3l8.6-0.1l-1.9-8.6l-8.8,0.1
        l1.8,8.2l-9.1,0.1l1.9,9h-7.4l-1.7-8.2h7.2l-2-9.7l-8.8,0.1l1.8,8.9h-7.2l2,9.7h7.4l1.7,8.4h-7.9l-1.9-9.1h-8l-1.7-8.2h7.9l-2-9.7
        l-8.8,0.1l1.8,8.9l-7.8,0.1l-1.9-9l-9.7,0.1l1.9,9.5h-7.7l-1.4-9.5l-9.7-0.4l1.5,9.6h-9.8l-1.4-9.5l-8.9,0.1l1.5,9.9l-7.9,0
        l-1.4-9.9l-8.9,0.1l1.4,9.9l-7.8,0.1l-1.4-10l-9.6,0.1l1.5,10.5l9-0.1l1.4,9.2l8.8-0.1l-1.4-9.3l7.8-0.1l2.2,9.4l8.8-0.1l-1.4-9.7
        l7.6-0.1l1.8,9.7l10.4-0.1l-1.8-9.9l8.7,0.3l1.5,9.5h8.8l-1.4-9.5l8.8-0.1l2,9.4l8.4-0.1l1.7,8H997l-0.6-8.5l-7.1,0.1l-0.7-9.4
        l-8.5,0.1l0.7,8.9l-8.4,0.1l0.6,8.6h-9.5l-0.6-8.5l-7.1,0.1l-0.7-8.8l7.7-0.1l0.7,9.5l8.5-0.1l-0.7-9.3l8.4-0.1l-0.8-10.1l-8.5,0.1
        l0.7,9.3l-7.7,0.1l-0.7-9.5l-8.5,0.1l0.7,9.5l-8.1,0.1l-0.7-9.8l-8.5,0.1l0.7,9.8l-8.8,0.1l0.8,10.4l8.1-0.1l0.5,7.1h-8.3l-0.6-8
        l-8.5,0.1l0.6,7.9H912l-0.7-8.7l-8.5,0.1l0.6,8.6h-9.5l-0.6-8.5l-7.1,0.1l-0.6-7.9l7.7-0.1l0.6,8.6l8.5-0.1l-0.7-9.2l8.9-0.2
        l1.2,9.6l8.5-0.1l-0.7-9.3l8.3-0.2l-0.7-10l-8.6,0.1l0.7,9.3l-8.5,0l-0.7-9.4l-9.4,0.1l0.7,9.2l-8.1,0.1l-0.6-8.6l-8.5,0.1l0.6,8.6
        l-7.7,0.1l-0.6-8.6l-8.5,0.1l0.7,8.6l-8.3,0.1l-0.6-8.6l-8.5,0.1l0.8,10.1l7.9-0.1l0.7,8.9l8.1-0.1l0.5,7.1H861l-0.6-8l-8.5,0.1
        l0.6,7.9l-14.9-0.1l-0.8-10.1l-8.4,0.1l-0.6-8.2l8.2-0.2l-0.8-10l-8.5,0.1l0.7,9.2l-8.8,0.1l0.8,10.1l9-0.1l0.7,9h-9.5l-0.7-9.9
        l-7.1,0.1l-0.6-8.5l6.9-0.1l-0.8-10.1l-8.5,0.1l0.7,9.2l-6.9,0.1l0.8,10.1l7.1-0.1l0.7,9.1h-7.7l-0.7-9.7l-7.7,0.1l-0.6-8.5
        l7.6-0.1l-0.8-10.1l-8.5,0.1l0.7,9.2l-7.9,0.1l0.8,10.4l8.1-0.1l0.6,8.5h-8.3l-0.7-9.5l-8.5,0.1l0.7,9.3h-9.1l-0.2-8.1l8.3-0.1
        l-0.2-9.7l8.2-0.1l-0.8-10.1l-8.5,0.1l0.7,9.7l-7.9,0.1l-0.8-9.6l-8.5,0.2l0.2,9.1l-8.8,0.1l0.3,10.1l9.2-0.1l0.2,8.3h-9.5
        l-0.2-8.7l-7.1,0.1l-0.2-9.2l6.9-0.1l-0.2-10.1l-8.5,0.1l0.2,9.9l-6.9,0.1l0.2,10.1l7.1-0.1l0.2,7.9h-7.7l-0.2-8.5l-7.7,0.1
        l-0.2-9.2l7.6-0.1l-0.2-10.1l-8.5,0.1l0.2,9.9l-7.1,0.1l-0.3-9.3l-10.1,0.2l0.3,10l9.3-0.1l0.2,9.6l8.1-0.1l0.2,7.4h-8.3l-0.2-8.3
        l-8.5,0.1l0.2,8.2h-87.5l0.2-8.6h8.2l0.2-8.4l8.9-0.1l-0.2,9.2l10-0.1l0.2-9.2l8.5-0.1l-0.2,8.9l8.7-0.1l0.2-8.8l6.6-0.1l-0.2,8.8
        h10l0.2-8.3l8.8-0.7l0.2-9.9l-8.7,0.1l-0.7,8.9l-9.2,0.1l0.2-8.9l-8.7,0.1l-0.2,8.9h-6l0.2-8.8l-10.5,0.1l-0.1,8.8l-8.5,0.1
        l0.2-8.9l-9.7,0.1l-0.2,8.4l-8.1,0.1l0.1-9.1l-9.2,0.1l-0.2,8.9l-7.7,0.1l0.2-9.5l-10.2,0.1l-0.2,8.9l-7,0.1l-0.2,9.9l7.2-0.1
        l-0.2,9.1h-7.8l0.2-9.7l-7.9,0.1l0.2-8.2l7.6-0.1l0.2-9.9l-8.7,0.1l-0.2,8.9l-7.7,0.1l0.2-8.4l-9.5,0.1l-0.2,9.9l9.2-0.1l-0.2,8.7
        l8.2-0.1l-0.2,8.6H570l0.2-9.5l-8.7,0.1l-0.2,9.4H453.9l0.4-9.1L447,237l0.4-9l7.9,0.1l-0.4,9.7l8.8,0.1l0.4-9l8.6,0.1l0.4-9.8
        l-8.8-0.1l-0.4,9l-8.1-0.1l0.4-9.7l-8.8-0.1l-0.4,9.7l-7.9-0.1l0.4-9.7l-8.8-0.1l-0.4,9.8l8.3,0.1l-0.4,9.7l7.3,0.1l-0.4,8.6h-7.9
        l0.4-9.3l-8-0.1l0.4-9.1l-8.3-0.1l0.4-9.7l-8.8-0.1l-0.4,9.4l-7.6-0.1l0.4-9.2l-8.8-0.1l-0.4,9.8l8.2,0.1l-0.4,9.2l7,0.1l-0.4,9.2
        H252.4l1.3-8.7h-7.6l1.1-7.9h8.2l-1.2,8.6h9.1l1.2-8.4h9.2l-1.3,8.9l9.4,0.1l1.3-8.9l8.9-0.1l-1.3,8.7h9.1l1.3-8.6l8.1,0.2
        l-1.2,8.4l9.1,0.1l1.2-8.8h9l-1.3,8.7l9.1,0.1l1.2-8.7h8.9l1.5-9.9h-9.1l-1.3,8.7h-8.8l1.2-8.7l-9.1-0.1l-1.2,8.8h-8.6l0.7-8.6
        h-9.1l-1.2,8.5h-7.9l1-8.6h-9.1l-1.3,8.6l-8.8-0.1l1.2-8.5l-9-0.1l-1.7,8.4h-8.2l1.2-8.6h-9.1l-1.2,8.6h-8.2l1.2-8.6h-9.1l-1.4,9.9
        h8.3l-1.2,8.6h7.6l-1.2,8.1h-8.2l1.3-8.8h-8.2l1.3-9.2h-8.3l1.2-8.6h-9.1l-1.4,9.9h7.9l-1.3,8.9h8.6l-1.1,7.8h-8.8l1.3-8.9h-9.1
        l-1.3,8.9h-25.4l1.6-8.2h-7.5l1.7-8.7h8.1l-1.8,9.4h9l1.8-9.4h9l2-10.1h-9l-1.8,9.4h-8.3l1.8-9.4h-9l-1.8,9.4h-8.1l1.8-9.4h-9
        l-2,10.1h8.4l-1.8,9.4h7.5l-1.5,7.5h-8.1l1.6-8.2H159l1.8-9.4h-8.4l1.8-9.4h-9l-1.9,9.4h-8.2l2.8-9.8h-9l-2.8,10h8.4l-2.8,9.8h8.3
        l-1.5,7.6h-27.3l2.4-8.6h-7.2l2.5-9h8l-2.7,9.7h9l2.8-10h-8.4l2.7-9.8h-9l-2.7,9.7h-7.8l2.7-9.7h-9l-2.7,9.7h-8.1l2.7-9.7h-9
        L75,229h8.2l-2.7,9.7H88l-2.2,7.9h-8.1l2.4-8.6H72l2.6-9.4h-8.2l2.7-9.7h-9L57.3,229h8.2l-2.7,9.7H71l-2.2,7.9H60l2.4-8.6h-9
        l-2.4,8.6H22.5L7,301.9h1162.1v-55.3H1139z M102.6,246.7h-7.8l2.4-8.6h-7.5l2.5-9h8.1l-2.7,9.7h7.2L102.6,246.7z M156.4,246.4h-8.8
        l1.6-8.2H141l2.4-8.7h7.8l-1.9,9.7h8.5L156.4,246.4z M428.3,246.3h-8.6l0.4-9.5l-7-0.1l0.4-9l7.3,0.1l-0.4,10l8.3,0.1L428.3,246.3z
        M621.9,236.7l-8.2,0.1l-0.2,9.3h-9.7l0.2-9.8l-7.2,0.1l0.2-8.2l7.8-0.1l-0.2,9.4h8.7l0.2-8.9l8.6-0.1L621.9,236.7z M760.8,237.2
        l-0.3-8.6l8-0.2l0.2,8.7L760.8,237.2z M877.7,246.6l-0.6-8.3l-7.7,0.1l-0.6-7.9l8.3-0.1l0.6,8.6l7.1-0.1l0.6,7.7H877.7z
        M947.3,246.7l-0.6-8.3l-7.7,0.1l-0.7-9.1l8.3-0.1l0.7,9.8l7.1-0.1l0.6,7.7H947.3z M981.6,246.7l-0.6-7.6l7-0.1l0.6,7.7H981.6z"
      />
      <g>
        <polygon class="st14" points="924,282.6 923.3,272.5 914.8,272.6 915.5,282.7" />
        <polygon
          class="st14"
          points="1056.4,283.8 1057.8,292.1 1066.4,292 1064.6,281.9 1058.1,282 1056.8,273.9 1048.1,274 
          1049.7,283.8"
        />
        <polygon
          class="st14"
          points="1074.2,283.6 1075.7,292.1 1084.3,292 1082.5,281.9 1074.8,282 1073.4,273.8 1064.7,273.8 
          1066.3,283.7"
        />
        <polygon
          class="st14"
          points="1125.8,282.8 1127.4,292.1 1135.9,292 1134.1,281.9 1129.4,282 1127.9,273 1119.2,273.1 
          1120.8,282.9"
        />
        <g>
          <polygon class="st14" points="613.5,282.4 604.8,282.5 604.6,292.4 613.3,292.3" />
          <polygon class="st14" points="570.4,274 561.7,274.1 561.5,283.9 570.2,283.9" />
          <polygon class="st14" points="622.5,273.5 613.8,273.6 613.6,283.4 622.3,283.4" />
          <path
            class="st14"
            d="M1162,301.2L1162,301.2l-1.7-9.8l-7.1,0.1l-1.6-8.7l11.8,0.1l-1.7-9.8l-12.3-0.1l1.5,9.2l-4.4,0.1l-1.5-9.2
            l-8.7,0.1l1.6,9.8l5.2-0.1l1.5,8.3l-8.4,0.1l1.8,10h-9.5l-1.7-9.9l-7.1,0.1l-1.7-9.4l-7.8,0.1l-1.6-9.3l-8.7,0.1l1.6,9.8l8-0.1
            l1.7,9.6l7.1-0.1l1.6,9.1h-7.7l-1.7-9.7l-7.7,0.1l-1.6-9.4l-8.5,0.1l-1.6-9.6l-8.7,0.1l1.6,9.8l8.4-0.1l1.8,10.2l8.1-0.1l1.5,8.5
            h-8.3l-1.7-9.4l-8.5,0.1l1.6,9.3h-14.6l4.6-0.1l-1.8-10.1l-8.5,0.1l1.8,10h-9.5l-1.7-9.9l-7.1,0.1l-1.7-9.4l-7.5,0.1l-1.4-8.1
            l-8.7,0.1l1.6,9.8l7.7-0.1l1.5,8.4l7.1-0.1l1.6,9.1h-7.7l-1.7-9.7l-7.7,0.1l-1.6-9.4l-8.4,0.1l-1.4-8.4l-8.7,0.1l1.6,9.8l8.3-0.1
            l1.6,9l8.1-0.1l1.5,8.5h-23.8l-0.7-9.9l-7.1,0.1l-0.7-9.4l-8.5,0.1l0.7,8.9l-8.4,0.1l0.8,10H977l-0.7-9.9l-7.1,0.1l-0.7-8.8
            l7.7-0.1l0.7,9.5l8.5-0.1l-0.7-9.3l8.4-0.1l-0.8-10.1l-8.5,0.1l0.7,9.3l-7.7,0.1l-0.7-9.5l-8.5,0.1l0.7,9.5l-8.1,0.1l-0.7-9.8
            L951,272l0.7,9.8l-8.8,0.1l0.8,10.4l8.1-0.1l0.6,8.5h-8.3l-0.7-9.4l-8.5,0.1l0.7,9.3H921l4.6-0.1l-0.8-10.1l-8.5,0.1l0.8,10h-9.5
            l-0.7-9.9l-7.1,0.1l-0.6-7.9l7.7-0.1l0.6,8.6l8.5-0.1l-0.8-10.1l-8.3,0.1l-0.6-8.6l-8.5,0.1l0.6,8.6l-7.7,0.1l-0.6-8.6l-8.5,0.1
            l0.8,10.1l8.3-0.1l0.6,8.6l7.1-0.1l0.7,9.1H891l-0.7-9.7l-7.7,0.1l-0.7-9.4l-8.3,0.1l-0.6-8.6l-8.5,0.1l0.8,10.1l7.9-0.1l0.7,8.9
            l8.1-0.1l0.6,8.5h-8.3l-0.7-9.4L865,292l0.7,9.3H850l-0.7-11.1l-8.2,0.2l-0.7-8.5l8.1-0.1l-0.8-10.1l-8.5,0.1l0.7,9.2l-8.8,0.1
            l0.8,10.1l8.8-0.1l0.7,10.2H832l-0.8-10.8l-7,0.1l-0.7-8.5l7-0.1l-0.8-10.1l-8.5,0.1l0.7,9.2l-7,0.1l0.8,10.1l7.1-0.1l0.7,10
            h-7.7l-0.7-10.6l-7.8,0.1l-0.6-8.5l7.6-0.1l-0.8-10l-8.5,0.1l0.7,9.2l-7.6,0.1l-0.7-9.2l-9.2,0.1l0.7,10.1l9-0.1l0.6,9.5l8.1-0.1
            l0.7,9.4H799l-0.8-10.4l-8.5,0.2l0.8,10.2h-18.7l-0.2-11l-8.1,0.1l-0.2-9.2l7.9-0.1l-0.3-10.1l-8.5,0.1l0.3,9.9l-9.5,0.1
            l-0.3-9.9l-8.5,0.2l0.2,9.8l-6.9,0.1l0.2,10.1l7.1-0.1l0.3,10h-7.7l-0.3-10.6l-7.7,0.1l-0.2-9.2l7.6-0.1l-0.3-10l-8.5,0.1
            l0.2,9.9l-7.5,0.1l-0.2-9.9l-10.3,0.1l0.2,10.1l10,0.2l0.3,9.9l8-0.1l0.3,9.4h-8.3l-0.3-10.3l-8.5,0.1l0.2,10.2h-90l0.2-9.8
            l-8.7,0.1l-0.2,9.7h-9.7l0.2-9.6l-7.2,0.1l0.1-8.2l7-0.1l0.2-9.8h-8.7l-0.2,8.9l-6.9,0.1l-0.2,9.8h7.2l-0.2,8.8h-7.8l0.2-9.4
            h-7.9l0.2-8.1l7.6-0.1l0.2-9.9l-8.7,0.1l-0.2,8.9h-8l-0.2,10.3l8.3-0.1l-0.2,8.3h-8.5l0.2-9.3l-8.7,0.1l-0.2,9.2h-100l0.9-9.7
            h-8.6l-0.9,9.7h-9.6l0.9-9.7h-7.2l0.7-8.5h7.8l-0.8,9.1h8.6l0.8-8.8h8.4l0.8-9.9h-8.6l-0.8,8.8H446l0.8-9.1h-8.6l-0.8,9.1h-7.8
            l0.8-9.1h-8.6l-0.9,9.9h8.1l-0.8,9.1h7.2l-0.8,9h-7.8l0.9-9.7h-7.8l0.8-9.3h-8.1l0.8-9.1h-8.6l-0.9,9.9h7.7l-0.8,9.5h8.2
            l-0.8,8.7h-8.4l0.9-9.7h-8.6l-0.9,9.7h-77l0.9-9.7h-7.4l0.7-8h8.8l0.9-10.1h-8.9l-0.8,8.7h-8l0.8-8.7h-8.9l-0.9,10.1h8.1
            l-0.8,8.7h7.4l-0.8,9h-8l0.9-9.7h-8.9l-0.9,9.7h-9.8l0.9-9.7h-7.4l0.7-8h8l-0.8,8.7h8.9l0.9-10.1h-8.1l0.8-8.7h-8.9l-0.8,8.7h-8
            l0.8-8.7h-9l-0.9,10.1h8.2l-0.8,8.7h7.4l-0.8,9h-8l0.9-9.7h-8.1l0.8-9.4h-8.1l0.8-8.7h-8.9l-0.9,10.1h7.8l-0.9,9.1h8.5l-0.8,8.6
            h-8.7l0.9-9.7h-8.9l-0.9,9.7h-9.9l0.9-9.7h-7.4l0.7-8h8l-0.8,8.7h8.9l0.9-10.1h-8.1l0.7-8.7h-8.9l-0.7,8.7h-8.1l0.8-8.7h-8.9
            l-0.9,10.1h8.2l-0.8,8.7h7.4l-0.8,9h-8l0.9-9.7h-8.1l0.8-9.4h-8.1l0.8-8.7h-8.9l-0.9,10.1h7.7l-0.8,9.1h8.5l-0.8,8.6h-8.7
            l0.9-9.7h-8.9l-0.9,9.7h-27.9l1.9-9.8h-7.5l1.7-8.7h8.1l-1.8,9.4h9l1.8-9.4h9l1.9-10.1h-9l-1.8,9.4h-8.3l1.8-9.4h-9l-1.8,9.4H152
            l1.8-9.4h-9l-2,10.1h8.4l-1.8,9.4h7.5l-1.8,9.1h-8l1.8-9.8h-8.2l1.9-9.4h-8.4l1.8-9.4h-9l-1.9,10.1h8l-1.9,9.7h8.5l-1.7,8.8h-8.7
            l1.8-9.8h-9l-1.8,9.8H86.9l2.7-9.8h-7.2l2.5-9h8.6l2.8-10.1h-9l-2.7,9.7h-7.8l2.7-9.7h-9l-2.7,9.7h-8.1l2.7-9.7h-9l-2.8,10.1h8.2
            l-2.7,9.7h7.5l-2.5,9.1H53l2.7-9.8h-8.2l2.6-9.4H42l2.7-9.7h-9l-2.8,10.1H41l-2.7,9.7h8.2l-2.5,9.1h-8.8l2.7-9.8h-9l-2.7,9.8h-23
            v38.2H1169v-38.2H1162z M77.9,301.3h-7.8l2.7-9.8h-7.5l2.5-9h8.1l-2.7,9.7h7.2L77.9,301.3z M746.4,290.6l-0.2-9.2l6.8-0.1
            l0.2,9.2L746.4,290.6z M753.8,301.3l-0.3-10.1l9.5-0.1l0.3,10.2H753.8z M960.6,301.3l-0.7-9.7l-7.7,0.1l-0.7-9.1l8.3-0.1l0.7,9.8
            l7.1-0.1l0.7,9.1H960.6z M990.2,301.3l4.6-0.1l-0.7-8.9l7-0.1l0.7,9.1H990.2z M1141.9,301.3l4.6-0.1l-1.6-8.9l7-0.1l1.6,9.1
            H1141.9z"
          />
        </g>
        <polygon
          class="st14"
          points="925,292.1 933.5,292 932.8,282.7 941.1,282.6 940.4,272.5 931.9,272.6 932.6,281.9 924.3,282"
        />
      </g>
      <g>
        <polygon class="st7" points="90.5,167 85.6,167 84.8,172.4 89.6,172.4" />
        <polygon class="st7" points="100.1,167 95.2,167 94.4,172.4 99.3,172.4" />
        <polygon class="st7" points="96.1,161.8 91.2,161.8 90.4,167.3 95.3,167.3" />
        <polygon class="st7" points="105.8,161.8 100.9,161.8 100,167.3 104.9,167.3" />
        <polygon class="st7" points="109.6,167 104.7,167 103.9,172.4 108.8,172.4" />
        <polygon class="st7" points="119.3,167 114.4,167 113.5,172.4 118.4,172.4" />
        <polygon class="st7" points="115.3,161.8 110.4,161.8 109.5,167.3 114.4,167.3" />
        <polygon class="st7" points="124.9,161.8 120,161.8 119.1,167.3 124,167.3" />
        <polygon class="st7" points="128.8,167 123.9,167 123,172.4 127.9,172.4" />
        <polygon class="st7" points="138.4,167 133.5,167 132.6,172.4 137.5,172.4" />
        <polygon class="st7" points="134.4,161.8 129.5,161.8 128.6,167.3 133.5,167.3" />
        <polygon class="st7" points="144,161.8 139.1,161.8 138.3,167.3 143.1,167.3" />
        <polygon class="st7" points="147.9,167 143,167 142.1,172.4 147,172.4" />
        <polygon class="st7" points="157.5,167 152.6,167 151.8,172.4 156.6,172.4" />
        <polygon class="st7" points="153.5,161.8 148.6,161.8 147.8,167.3 152.6,167.3" />
        <polygon class="st7" points="163.1,161.8 158.2,161.8 157.4,167.3 162.3,167.3" />
        <polygon class="st7" points="167.1,167 162.2,167 161.4,172.4 166.3,172.4" />
        <polygon class="st7" points="172.8,161.8 167.9,161.8 167,167.3 171.9,167.3" />
        <polygon class="st7" points="176.6,167 171.7,167 170.9,172.4 175.8,172.4" />
        <polygon class="st7" points="186.3,167 181.4,167 180.5,172.4 185.4,172.4" />
        <polygon class="st7" points="182.3,161.8 177.4,161.8 176.5,167.3 181.4,167.3" />
        <polygon class="st7" points="191.9,161.8 187,161.8 186.1,167.3 191,167.3" />
        <polygon class="st7" points="195.8,167 190.9,167 190,172.4 194.9,172.4" />
        <polygon class="st7" points="205.4,167 200.5,167 199.6,172.4 204.5,172.4" />
        <polygon class="st7" points="201.4,161.8 196.5,161.8 195.6,167.3 200.5,167.3" />
        <polygon class="st7" points="211,161.8 206.1,161.8 205.3,167.3 210.1,167.3" />
        <polygon class="st7" points="214.9,167 210,167 209.1,172.4 214,172.4" />
        <polygon class="st7" points="224.5,167 219.6,167 218.8,172.4 223.6,172.4" />
        <polygon class="st7" points="220.5,161.8 215.6,161.8 214.8,167.3 219.6,167.3" />
      </g>
      <g>
        <polygon class="st7" points="237.9,167 233,167 232.1,172.4 237,172.4" />
        <polygon class="st7" points="247.5,167 242.6,167 241.8,172.4 246.6,172.4" />
        <polygon class="st7" points="243.5,161.8 238.6,161.8 237.8,167.3 242.6,167.3" />
        <polygon class="st7" points="253.1,161.8 248.2,161.8 247.4,167.3 252.3,167.3" />
        <polygon class="st7" points="257,167 252.1,167 251.3,172.4 256.1,172.4" />
        <polygon class="st7" points="266.6,167 261.7,167 260.9,172.4 265.8,172.4" />
        <polygon class="st7" points="262.6,161.8 257.7,161.8 256.9,167.3 261.8,167.3" />
        <polygon class="st7" points="272.3,161.8 267.4,161.8 266.5,167.3 271.4,167.3" />
        <polygon class="st7" points="276.1,167 271.2,167 270.4,172.4 275.3,172.4" />
        <polygon class="st7" points="285.8,167 280.9,167 280,172.4 284.9,172.4" />
        <polygon class="st7" points="281.8,161.8 276.9,161.8 276,167.3 280.9,167.3" />
        <polygon class="st7" points="291.4,161.8 286.5,161.8 285.6,167.3 290.5,167.3" />
        <polygon class="st7" points="295.3,167 290.4,167 289.5,172.4 294.4,172.4" />
        <polygon class="st7" points="304.9,167 300,167 299.1,172.4 304,172.4" />
        <polygon class="st7" points="300.9,161.8 296,161.8 295.1,167.3 300,167.3" />
        <polygon class="st7" points="310.5,161.8 305.6,161.8 304.8,167.3 309.6,167.3" />
        <polygon class="st7" points="314.5,167 309.6,167 308.8,172.4 313.6,172.4" />
        <polygon class="st7" points="320.1,161.8 315.2,161.8 314.4,167.3 319.3,167.3" />
        <polygon class="st7" points="324,167 319.1,167 318.3,172.4 323.1,172.4" />
        <polygon class="st7" points="333.6,167 328.7,167 327.9,172.4 332.8,172.4" />
        <polygon class="st7" points="329.6,161.8 324.7,161.8 323.9,167.3 328.8,167.3" />
        <polygon class="st7" points="339.3,161.8 334.4,161.8 333.5,167.3 338.4,167.3" />
        <polygon class="st7" points="343.1,167 338.2,167 337.4,172.4 342.3,172.4" />
        <polygon class="st7" points="352.8,167 347.9,167 347,172.4 351.9,172.4" />
        <polygon class="st7" points="348.8,161.8 343.9,161.8 343,167.3 347.9,167.3" />
        <polygon class="st7" points="358.4,161.8 353.5,161.8 352.6,167.3 357.5,167.3" />
      </g>
      <g>
        <polygon class="st7" points="379.8,167 375,167 374.5,172.4 379.4,172.4" />
        <polygon class="st7" points="389.5,167 384.6,167 384.2,172.4 389,172.4" />
        <polygon class="st7" points="385.1,161.8 380.2,161.8 379.7,167.3 384.6,167.3" />
        <polygon class="st7" points="375.8,161.8 370.9,161.8 370.5,167.3 375.4,167.3" />
        <polygon class="st7" points="394.7,161.8 389.8,161.8 389.4,167.3 394.3,167.3" />
        <polygon class="st7" points="399,167 394.1,167 393.7,172.4 398.5,172.4" />
        <polygon class="st7" points="408.6,167 403.7,167 403.3,172.4 408.2,172.4" />
        <polygon class="st7" points="404.2,161.8 399.3,161.8 398.9,167.3 403.8,167.3 		" />
        <polygon class="st7" points="413.8,161.8 408.9,161.8 408.5,167.3 413.4,167.3 		" />
        <polygon class="st7" points="418.1,167 413.2,167 412.8,172.4 417.7,172.4 		" />
        <polygon class="st7" points="427.7,167 422.8,167 422.4,172.4 427.3,172.4 		" />
        <polygon class="st7" points="423.3,161.8 418.4,161.8 418,167.3 422.9,167.3 		" />
        <polygon class="st7" points="432.9,161.8 428.1,161.8 427.6,167.3 432.5,167.3 		" />
        <polygon class="st7" points="437.2,167 432.3,167 431.9,172.4 436.8,172.4 		" />
        <polygon class="st7" points="446.8,167 442,167 441.5,172.4 446.4,172.4 		" />
        <polygon class="st7" points="442.4,161.8 437.6,161.8 437.1,167.3 442,167.3 		" />
        <polygon class="st7" points="452.1,161.8 447.2,161.8 446.7,167.3 451.6,167.3 		" />
        <polygon class="st7" points="456.5,167 451.6,167 451.2,172.4 456,172.4 		" />
        <polygon class="st7" points="461.7,161.8 456.8,161.8 456.4,167.3 461.3,167.3 		" />
        <polygon class="st7" points="466,167 461.1,167 460.7,172.4 465.5,172.4 		" />
        <polygon class="st7" points="475.6,167 470.7,167 470.3,172.4 475.2,172.4 		" />
        <polygon class="st7" points="471.2,161.8 466.3,161.8 465.9,167.3 470.8,167.3 		" />
        <polygon class="st7" points="480.8,161.8 475.9,161.8 475.5,167.3 480.4,167.3 		" />
        <polygon class="st7" points="485.1,167 480.2,167 479.8,172.4 484.7,172.4 		" />
        <polygon class="st7" points="494.7,167 489.8,167 489.4,172.4 494.3,172.4 		" />
        <polygon class="st7" points="490.3,161.8 485.4,161.8 485,167.3 489.9,167.3 		" />
        <polygon class="st7" points="504.2,167 499.3,167 498.9,172.4 503.8,172.4 		" />
        <polygon class="st7" points="513.8,167 509,167 508.5,172.4 513.4,172.4 		" />
        <polygon class="st7" points="523,167 518.1,167 517.7,172.4 522.5,172.4 		" />
        <polygon class="st7" points="509.4,161.8 504.6,161.8 504.1,167.3 509,167.3 		" />
        <polygon class="st7" points="518.7,161.8 513.8,161.8 513.4,167.3 518.3,167.3 		" />
        <polygon class="st7" points="499.9,161.8 495.1,161.8 494.6,167.3 499.5,167.3 		" />
      </g>
      <g>
        <polygon class="st7" points="572.2,166.9 567.2,166.9 567.1,172.4 572,172.4 		" />
        <polygon class="st7" points="581.9,166.9 577,166.9 576.8,172.4 581.7,172.4 		" />
        <polygon class="st7" points="577.2,161.7 572.2,161.7 572.1,167.2 577,167.2 		" />
        <polygon class="st7" points="567.8,161.7 562.9,161.7 562.7,167.2 567.7,167.2 		" />
        <polygon class="st7" points="586.9,161.7 582,161.7 581.8,167.2 586.7,167.2 		" />
        <polygon class="st7" points="591.5,166.9 586.6,166.9 586.4,172.4 591.3,172.4 		" />
        <polygon class="st7" points="601.2,166.9 596.3,166.9 596.1,172.4 601.1,172.4 		" />
        <polygon class="st7" points="596.5,161.7 591.6,161.7 591.4,167.2 596.3,167.2 		" />
        <polygon class="st7" points="606.2,161.7 601.3,161.7 601.1,167.2 606.1,167.2 		" />
        <polygon class="st7" points="610.8,166.9 605.9,166.9 605.7,172.4 610.7,172.4 		" />
        <polygon class="st7" points="615.8,161.7 610.9,161.7 610.7,167.2 615.7,167.2 		" />
        <polygon class="st7" points="644.9,161.7 640,161.7 639.8,167.2 644.8,167.2 		" />
        <polygon class="st7" points="649.6,166.9 644.7,166.9 644.5,172.4 649.5,172.4 		" />
        <polygon class="st7" points="654.6,161.7 649.7,161.7 649.5,167.2 654.5,167.2 		" />
        <polygon class="st7" points="659.2,166.9 654.3,166.9 654.2,172.4 659.1,172.4 		" />
        <polygon class="st7" points="669,166.9 664,166.9 663.9,172.4 668.8,172.4 		" />
        <polygon class="st7" points="664.2,161.7 659.3,161.7 659.2,167.2 664.1,167.2 		" />
        <polygon class="st7" points="674,161.7 669,161.7 668.9,167.2 673.8,167.2 		" />
        <polygon class="st7" points="678.6,166.9 673.6,166.9 673.5,172.4 678.4,172.4 		" />
        <polygon class="st7" points="688.3,166.9 683.4,166.9 683.2,172.4 688.2,172.4 		" />
        <polygon class="st7" points="683.6,161.7 678.6,161.7 678.5,167.2 683.4,167.2 		" />
      </g>
      <g>
        <polygon class="st7" points="710.8,167.1 705.9,167.1 706.1,172.6 711,172.6 		" />
        <polygon class="st7" points="720.6,167.1 715.6,167.1 715.8,172.6 720.7,172.6 		" />
        <polygon class="st7" points="715.5,161.9 710.6,161.9 710.8,167.4 715.7,167.4 		" />
        <polygon class="st7" points="706.2,161.9 701.2,161.9 701.4,167.4 706.4,167.4 		" />
        <polygon class="st7" points="725.3,161.9 720.3,161.9 720.5,167.4 725.4,167.4 		" />
        <polygon class="st7" points="730.2,167.1 725.2,167.1 725.4,172.6 730.3,172.6 		" />
        <polygon class="st7" points="739.9,167.1 735,167.1 735.1,172.6 740.1,172.6 		" />
        <polygon class="st7" points="734.9,161.9 729.9,161.9 730.1,167.4 735,167.4 		" />
        <polygon class="st7" points="744.6,161.9 739.7,161.9 739.8,167.4 744.8,167.4 		" />
        <polygon class="st7" points="788.3,167.1 783.4,167.1 783.5,172.6 788.5,172.6 		" />
        <polygon class="st7" points="793,161.9 788.1,161.9 788.2,167.4 793.2,167.4 		" />
        <polygon class="st7" points="797.9,167.1 793,167.1 793.2,172.6 798.1,172.6 		" />
        <polygon class="st7" points="807.7,167.1 802.7,167.1 802.9,172.6 807.8,172.6 		" />
        <polygon class="st7" points="802.6,161.9 797.7,161.9 797.9,167.4 802.8,167.4 		" />
        <polygon class="st7" points="812.3,161.9 807.4,161.9 807.6,167.4 812.5,167.4 		" />
        <polygon class="st7" points="817.3,167.1 812.3,167.1 812.5,172.6 817.4,172.6 		" />
        <polygon class="st7" points="827,167.1 822.1,167.1 822.2,172.6 827.2,172.6 		" />
        <polygon class="st7" points="822,161.9 817,161.9 817.2,167.4 822.1,167.4 		" />
      </g>
      <g>
        <polygon class="st7" points="847.4,167.1 842.5,167.1 842.9,172.6 847.9,172.6 		" />
        <polygon class="st7" points="857.1,167.1 852.2,167.1 852.7,172.6 857.6,172.6 		" />
        <polygon class="st7" points="851.8,161.9 846.9,161.9 847.4,167.4 852.3,167.4 		" />
        <polygon class="st7" points="842.5,161.9 837.5,161.9 838,167.4 842.9,167.4 		" />
        <polygon class="st7" points="861.6,161.9 856.6,161.9 857.1,167.4 862,167.4 		" />
        <polygon class="st7" points="866.7,167.1 861.8,167.1 862.3,172.6 867.2,172.6 		" />
        <polygon class="st7" points="876.5,167.1 871.5,167.1 872,172.6 876.9,172.6 		" />
        <polygon class="st7" points="871.2,161.9 866.2,161.9 866.7,167.4 871.6,167.4 		" />
        <polygon class="st7" points="880.9,161.9 876,161.9 876.4,167.4 881.4,167.4 		" />
        <polygon class="st7" points="886.1,167.1 881.2,167.1 881.7,172.6 886.6,172.6 		" />
        <polygon class="st7" points="890.6,161.9 885.6,161.9 886.1,167.4 891,167.4 		" />
        <polygon class="st7" points="895.7,167.1 890.8,167.1 891.3,172.6 896.2,172.6 		" />
        <polygon class="st7" points="905.5,167.1 900.5,167.1 901,172.6 905.9,172.6 		" />
        <polygon class="st7" points="900.2,161.9 895.2,161.9 895.7,167.4 900.6,167.4 		" />
        <polygon class="st7" points="909.9,161.9 905,161.9 905.4,167.4 910.4,167.4 		" />
        <polygon class="st7" points="915.2,167.1 910.3,167.1 910.8,172.6 915.7,172.6 		" />
        <polygon class="st7" points="925,167.1 920,167.1 920.5,172.6 925.4,172.6 		" />
        <polygon class="st7" points="919.7,161.9 914.7,161.9 915.2,167.4 920.1,167.4 		" />
        <polygon class="st7" points="929.4,161.9 924.5,161.9 924.9,167.4 929.9,167.4 		" />
        <polygon class="st7" points="934.5,167.1 929.5,167.1 930,172.6 935,172.6 		" />
        <polygon class="st7" points="944.2,167.1 939.3,167.1 939.7,172.6 944.7,172.6 		" />
        <polygon class="st7" points="938.9,161.9 934,161.9 934.4,167.4 939.4,167.4 		" />
        <polygon class="st7" points="948.6,161.9 943.7,161.9 944.2,167.4 949.1,167.4 		" />
        <polygon class="st7" points="953.8,167.1 948.9,167.1 949.4,172.6 954.3,172.6 		" />
        <polygon class="st7" points="963.6,167.1 958.6,167.1 959.1,172.6 964,172.6 		" />
        <polygon class="st7" points="958.2,161.9 953.3,161.9 953.8,167.4 958.7,167.4 		" />
        <polygon class="st7" points="967.7,161.9 962.8,161.9 963.3,167.4 968.2,167.4 		" />
      </g>
      <g>
        <polygon class="st7" points="987.1,167.1 982.2,167.1 983,172.6 987.9,172.6 		" />
        <polygon class="st7" points="996.9,167.1 991.9,167.1 992.7,172.6 997.6,172.6 		" />
        <polygon class="st7" points="991.3,161.9 986.4,161.9 987.1,167.4 992,167.4 		" />
        <polygon class="st7" points="981.9,161.9 977,161.9 977.7,167.4 982.7,167.4 		" />
        <polygon class="st7" points="1001,161.9 996.1,161.9 996.8,167.4 1001.8,167.4 		" />
        <polygon class="st7" points="1006.5,167.1 1001.5,167.1 1002.3,172.6 1007.2,172.6 		" />
        <polygon class="st7" points="1016.2,167.1 1011.3,167.1 1012,172.6 1017,172.6 		" />
        <polygon class="st7" points="1010.6,161.9 1005.7,161.9 1006.4,167.4 1011.4,167.4 		" />
        <polygon class="st7" points="1020.4,161.9 1015.4,161.9 1016.2,167.4 1021.1,167.4 		" />
        <polygon class="st7" points="1025.9,167.1 1020.9,167.1 1021.7,172.6 1026.6,172.6 		" />
        <polygon class="st7" points="1030,161.9 1025.1,161.9 1025.8,167.4 1030.8,167.4 		" />
        <polygon class="st7" points="1035.5,167.1 1030.5,167.1 1031.3,172.6 1036.2,172.6 		" />
        <polygon class="st7" points="1045.2,167.1 1040.3,167.1 1041,172.6 1046,172.6 		" />
        <polygon class="st7" points="1039.6,161.9 1034.7,161.9 1035.4,167.4 1040.4,167.4 		" />
        <polygon class="st7" points="1049.4,161.9 1044.4,161.9 1045.2,167.4 1050.1,167.4 		" />
        <polygon class="st7" points="1055,167.1 1050,167.1 1050.8,172.6 1055.7,172.6 		" />
        <polygon class="st7" points="1064.7,167.1 1059.8,167.1 1060.5,172.6 1065.5,172.6 		" />
        <polygon class="st7" points="1059.1,161.9 1054.2,161.9 1054.9,167.4 1059.9,167.4 		" />
        <polygon class="st7" points="1068.9,161.9 1063.9,161.9 1064.7,167.4 1069.6,167.4 		" />
        <polygon class="st7" points="1074.2,167.1 1069.3,167.1 1070,172.6 1075,172.6 		" />
        <polygon class="st7" points="1084,167.1 1079,167.1 1079.8,172.6 1084.7,172.6 		" />
        <polygon class="st7" points="1078.4,161.9 1073.4,161.9 1074.2,167.4 1079.1,167.4 		" />
        <polygon class="st7" points="1088.1,161.9 1083.2,161.9 1083.9,167.4 1088.8,167.4 		" />
        <polygon class="st7" points="1093.6,167.1 1088.6,167.1 1089.4,172.6 1094.3,172.6 		" />
        <polygon class="st7" points="1103.3,167.1 1098.4,167.1 1099.1,172.6 1104,172.6 		" />
        <polygon class="st7" points="1097.7,161.9 1092.8,161.9 1093.5,167.4 1098.5,167.4 		" />
        <polygon class="st7" points="1107.2,161.9 1102.3,161.9 1103,167.4 1108,167.4 		" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "TheTitle",
};
</script>

<style lang="scss" scoped>
.ttl {
  display: block;
  position: fixed;
  width: 46%;
  max-width: 1300px;
  min-width: 900px;
  animation: fade-ttl 1s forwards;
  opacity: 0;
  left: 0;
  right: 0;
  top: 8%;
  margin: 0 auto;
  z-index: 99;

  @media (max-width: 600px) {
    min-width: auto;
    width: 86%;
  }
  .st0 {
    opacity: 0;
    animation: 1s fade2 0.8s forwards;
    fill: #0f0d0c;
  }
  .st1 {
    fill: #2d2112;
  }
  .st2 {
    fill: #3d2e17;
  }
  .st3 {
    fill: #302312;
  }
  .st4 {
    filter: url(#filter-mask);
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    mask: url(#ttl-mask);
  }
  .st7 {
    fill: #fbaf2c;
  }
  .st8 {
    fill: #fac029;
  }
  .st9 {
    fill: #f9d226;
  }
  .st10 {
    fill: #f9e224;
  }
  .st11 {
    fill: #f8f421;
  }
  .st12 {
    fill: #fc8d32;
  }
  .st13 {
    fill: #fd6b38;
  }
  .st14 {
    fill: #ff483e;
  }
}
</style>
